import React from "react";
import { compose } from "recompose";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as dialogActions from "../../actions/dialogActions";

import Loader from "../Loader";
import Info from "./Info";
import OrganizationUserAdministration_Dialog from "./OrganizationUserAdministration_Dialog";
import DeleteOrganizationUserBinding from "./DeleteOrganizationUserBinding";
import AdminResourcesRemoveResource from "./AdminResourcesRemoveResource";
import AdminResourceDeleteRights from "./AdminResourceDeleteRights";
import SettingsNewOrganization from "./SettingsNewOrganization";
import AdminResourceEditRights from "./AdminResourceEditRights";
import DeleteRelatedResource from "./DeleteRelatedResource";

const Dialogs = ({
  setDialog,
  closeDialog,
  addDialogData,
  data,
  history,
  loader
}) => {
  const dialogProps = {
    setDialog,
    closeDialog,
    addDialogData,
    data,
    history
  };
  return (
    <div>
      {loader && <Loader />}
      <Info {...dialogProps} />
      <DeleteRelatedResource {...dialogProps} />
      <AdminResourceEditRights {...dialogProps} />
      <SettingsNewOrganization {...dialogProps} />
      <AdminResourceDeleteRights {...dialogProps} />
      <AdminResourcesRemoveResource {...dialogProps} />
      <DeleteOrganizationUserBinding {...dialogProps} />
      <OrganizationUserAdministration_Dialog {...dialogProps} />
    </div>
  );
};

export default compose(
  withRouter,
  connect(({ dialog: { data }, app: { loader } }) => ({ data, loader }), {
    ...dialogActions
  })
)(Dialogs);



// WEBPACK FOOTER //
// ./src/components/dialogs/index.js